import { Button } from "@/components/ui/button";

export default function TermsAndConditions() {
    function handleGoBack() {
        window.history.back();
    }
    return (
        <div className="relative min-h-screen w-full flex items-center justify-center overflow-y-auto hideScrollBars">


            <div className="absolute inset-0 backdrop-blur z-10" />

            <div className="z-10 overflow-scroll hideScrollBars py-8 backdrop-blur max-sm:backdrop-blur-sm flex-1 max-h-screen h-fit ">
                <div className={"flex items-center justify-center "}>
                    <div className=" max-w-3xl bg-white rounded-lg shadow-lg p-6 max-md:w-[95%] sm:p-10 md:p-12 lg:p-16 overflow-y-auto">
                        <h1 className="text-3xl font-bold mb-6 text-orange text-center underline ">Terms and Conditions</h1>
                        <div className="prose max-w-none text-gray-800 text-base sm:text-lg leading-relaxed">
                            <strong>
                                Travel Buddy - Disclaimer
                            </strong>
                            <br />
                            Regarding the Use of Travel Buddy
                            <hr />
                            <br />
                            The Travel Buddy application has been developed solely as part of the teaching and learning process at Manipal University Jaipur (MUJ). It is a non-commercial, internal-use platform created to facilitate shared travel coordination among members of the MUJ community, including students, faculty, and staff.
                            <br />
                            <br />
                            Please note the following important points: <hr /><br />
                            <ol className="list-disc list-inside" >
                                <li >Travel Buddy is not a commercial ride-sharing or transportation service. It merely connects individuals who are independently planning to travel the same route, allowing them to voluntarily coordinate their journeys.
                                </li>
                                <li>Users are solely responsible for their travel decisions. All communications, meeting arrangements, and shared rides facilitated through the platform are entirely at the users own discretion and risk.
                                </li>
                                <li>No background checks or verification of users are performed by the university or the developers. Users are advised to exercise personal judgment and caution when connecting with others through the platform.
                                </li>
                                <li>Manipal University Jaipur and the developers of this application bear no responsibility or liability for any personal, legal, or financial consequences arising out of the use of this app or any travel arrangements made via it.
                                </li>

                            </ol>
                            <br />
                            By using this application, you acknowledge and accept that:
                            <hr /><br />
                            <ul className="list-disc list-inside">
                                <li>The platform is experimental and educational in nature.
                                </li>
                                <li>You are responsible for your own safety, decisions, and interactions.
                                </li>
                                <li>You release MUJ and the development team from any liability arising from the use of this service.
                                </li>
                            </ul>
                            <br />

                            <strong >
                                If you do not agree with these terms, please do not use the Travel Buddy platform.
                            </strong>

                        </div>

                        <div className="w-full flex justify-center items-center">
                            <Button variant={"default"} size={"lg"} className="hover:bg-amber-500  text-white " onClick={handleGoBack} >Go Back</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}